import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverDataModule } from './driver-data/driver-data.module';

@NgModule({
  imports: [
    CommonModule,
    DriverDataModule
  ]
})
export class SharedDriverDataAccessDriverModule {}
